module.exports = __webpack_public_path__ + "img/banner05_info_S_3.44b66b64.png";